
<div class="banniere-wrapper">
  <img class="hide-when-large" style="height: 100%; max-height: 250px" src="banniere/kiki-gauche.png" alt="image ulqui">
  <div class="content-text-banniere">
    <div class="global-container">
      <div [ngStyle]="{'background-color': 'var(--color-doggoverse-emeraude-dark)'}" style="width: 100%; height: 65px; overflow: hidden; z-index: 1">
        <div
          class="word"
        >
          <div
            [ngStyle]="{'background-color': 'var(--color-doggoverse-emeraude-dark)'}"
            style="color: #F1EEDA"
          ><b>Doggo</b>
          </div>

          <div
            [ngStyle]="{'background-color': 'var(--color-doggoverse-emeraude-dark)'}"
            class="container-word-animation"
          >
      <span
        class="word-animation"
      >
        <span class="verse"><b>verse</b></span>
        <span class="shop"><b>Shop</b></span>
        <span class="cafe"><b>Café</b></span>
        <span class="wash"><b>Wash</b></span>
        <span class="events"><b>Events</b></span>
        <span class="verse"><b>verse</b></span>
      </span>
          </div>
        </div>
      </div>
    </div>

    <div class="container-title">
      <span style="font-size: 36px; text-align: center; color: var(--color-doggoverse-jaune); font-weight: bold">
        Explorer l'univers de votre chien
      </span>
    </div>
  </div>
  <img class="hide-when-large" style="height: 100%; max-height: 250px" src="banniere/kiki-droite.png" alt="image ulqui">
</div>



